var zh_CN = {
  "Add Quantity Breaks to your product page": "将数量折扣添加到您的产品页面",
  "Add Upsell.com to your ": "将 Upsell.com 添加到您的 ",
  "Add to cart click": "加入购物车点击",
  "All time": "所有时间",
  "and select": "并选择",
  "button": "按钮",
  "Cart drawer page": "购物车抽屉页面",
  "Cart page": "购物车页面",
  "Check status": "检查状态",
  "Checkout page": "结账页面",
  "Checkout click": "结账点击",
  "Click": "点击",
  "Click on": "点击",
  "Click the": "点击",
  "Custom slot": "自定义插槽",
  "Custom slots": "自定义插槽",
  "Custom Slots": "自定义插槽",
  "Enable in theme editor": "在主题编辑器中启用",
  "contact support.": "联系客服。",
  "from the right sidebar": "从右侧边栏",
  "Go to App Embeds": "前往应用嵌入",
  "Go to your Cart drawer page": "前往您的购物车抽屉页面",
  "Go to your Cart page": "前往您的购物车页面",
  "Go to your Checkout page": "前往您的结账页面",
  "Go to your Order status page": "前往您的订单状态页面",
  "Go to your Post purchase page": "前往您的购买后页面",
  "Go to your Product page": "前往您的产品页面",
  "Go to your Thank you page": "前往您的感谢页面",
  "items": "项目",
  "in the left sidebar": "在左侧边栏中",
  "Last 12 months": "过去 12 个月",
  "Last 30 days": "过去 30 天",
  "Last 365 days": "过去 365 天",
  "Last 7 days": "过去 7 天",
  "Last 90 days": "过去 90 天",
  "Last month": "上个月",
  "Last year": "去年",
  "Make sure": "确保",
  "Need assistance? Contact our support team for help.": "需要帮助？请联系我们的支持团队。",
  "Order status page": "订单状态页面",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "我们的应用目前正在进行一些优化，以提升您的体验。",
  "Post purchase page": "购买后页面",
  "Product page": "产品页面",
  "Save": "保存",
  "Scroll to the bottom and select": "滚动到底部并选择",
  "Select": "选择",
  "Success. Please continue.": "成功。请继续。",
  "Thank you page": "感谢页面",
  "The Upsell.com team.": "Upsell.com 团队。",
  "The Upsell.com widget is not placed on ": "Upsell.com 小部件未放置在 ",
  ". Please follow the steps above or ": " 上。请按照上述步骤操作或 ",
  "Today": "今天",
  "toggle is on": "开关已开启",
  "Total": "总计",
  "under": "在",
  "We apologize for any inconvenience caused,": "对于造成的任何不便，我们深表歉意，",
  "We apologize for any inconvenience caused.": "对于造成的任何不便，我们深表歉意。",
  "We'll be done in a few minutes!": "我们将在几分钟内完成！",
  "We're improving our services!": "我们正在改进我们的服务！",
  "Widget already added": "小部件已添加",
  "Yesterday": "昨天",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "您已在在线商店中启用该小组件，但未在 Upsell 编辑器中保存",
  "You placed the widget on the ": "您已将小部件放置在 ",
  ", but you didn't save it in Shopify editor. Please go back to ": " 上，但您没有在 Shopify 编辑器中保存。请返回 ",
  " and save the changes.": " 并保存更改。"
};

export { zh_CN as default };
//# sourceMappingURL=zh-CN.json.js.map
